import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import data from './data';
import meta from './meta';
import ui from './ui';
import user from './user';

const rootReducer = (history) =>
  combineReducers({
    meta,
    data,
    ui,
    user,
    router: connectRouter(history)
  });

export default rootReducer;
